import { SummaryContentComponentElement } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SUMMARY_BASE_PATH } from '../constants/summaryBasePath';

export const getSummaryComponentsForApplication = async (
  constructGet: ConstructGet,
  definitionName: string,
  path: string,
): Promise<
  NonPaginatedResponse<SummaryContentComponentElement[]> | undefined
> =>
  constructGet(
    `${SUMMARY_BASE_PATH}/${path}`,
    {
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
